var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60355 4.64645C5.7838 4.82669 5.79766 5.1103 5.64515 5.30645L5.60355 5.35355L1.10355 9.85355C0.908291 10.0488 0.591709 10.0488 0.396447 9.85355C0.216205 9.67331 0.20234 9.3897 0.354852 9.19355L0.396447 9.14645L4.5425 5L0.396447 0.853553C0.216205 0.673311 0.20234 0.389696 0.354852 0.19355L0.396447 0.146447C0.576689 -0.0337954 0.860304 -0.0476601 1.05645 0.104852L1.10355 0.146447L5.60355 4.64645Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/SideArrow.4542b5d4cd902156e8415e9153ca1dcf.svg";
export { ForwardRef as ReactComponent };